import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import WebinarSessionDateTimeInterface from 'common/types/entities/WebinarSessionDateTimeInterface'
import WebinarSessionLinkInterface from 'common/types/entities/WebinarSessionLinkInterface'
import React from 'react'
import createCommonEntitySettings from '../createCommonEntitySettings'
import WebinarSessionDateTimeSettings from './settings/WebinarSessionDateTimeSettings'
import WebinarSessionLinkSettingsNew from './settings/WebinarSessionLinkSettingsNew'

function createSettingsForWebinarThankYou(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.WebinarSessionLink:
      return (
        <WebinarSessionLinkSettingsNew
          entity={entity as WebinarSessionLinkInterface}
          defaultEntity={defaultEntity as WebinarSessionLinkInterface}
        />
      )
    case EntityTypeEnum.WebinarSessionDateTime:
      return (
        <WebinarSessionDateTimeSettings
          entity={entity as WebinarSessionDateTimeInterface}
          defaultEntity={defaultEntity as WebinarSessionDateTimeInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForWebinarThankYou
